var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("moqs-discount-detail", {
    attrs: {
      "is-edit": _vm.isEdit
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };